import { render, staticRenderFns } from "./PurchaseReviewPage.vue?vue&type=template&id=4c1228a5&scoped=true&"
import script from "./PurchaseReviewPage.vue?vue&type=script&lang=js&"
export * from "./PurchaseReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseReviewPage.vue?vue&type=style&index=0&id=4c1228a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1228a5",
  null
  
)

export default component.exports